import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import MoveMoneyPayeeActionCreator from '../actions/MoveMoneyPayeeActionCreator';
import MoveMoneyPayeeStore from '../stores/MoveMoneyPayeeStore';
import SessionActionCreator from '../actions/SessionActionCreator';
import InternetBankingActions from '../actions/InternetBankingActions';
// Urls for service call
const _addPayeeUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{accountId}/beneficiaries/account';
const _deletePayeeUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{accountId}/beneficiaries/{beneficiaryId}';
const _putRetailPayeeUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{accountId}/beneficiaries/account/{beneficiaryId}';
const _getCompanyUrl = '/ibapi/v2/beneficiaries/biller/default';
const _addPCompanyUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{accountId}/beneficiaries/biller';
const _verifySrdUrl =
  '/ibapi/v2/banks/{bank-id}/default/account/srd-verification ';

const MoveMoneyPayeeApiUtils = {
  /**
   * method: addCompany
   * request: addCompany data and accountId
   * description:This method will make a ajax call to add a Company for a particular account
   */
  addCompany(requestData, accountId, isForEdit = false) {
    // replacing the accountId

    const addPCompanyUrl = _addPCompanyUrl.replace('{accountId}', accountId);
    let url = envConfig.apiBaseUrlPAAS + addPCompanyUrl;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.paymentStub.AddPayeeConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.payeeService,
        method: envConfig.stubConfig ? 'Get' : 'Post',
        url,
        requestData,
        addAuthToken: true,
      },
      (resp) => {
        const body = resp;
        body.code = 201;
        body.accountId = accountId;
        // Handling the success response
        MoveMoneyPayeeActionCreator.handleAddCompanyPayeeServiceCall(body);
      },
      (errors) => {
        if (errors !== undefined) {
          const error = errors;
          error.code = 422;
          // Handling the error response
          if (isForEdit) {
            MoveMoneyPayeeStore.errorToAddCompany(true);
          }
          MoveMoneyPayeeActionCreator.handleAddCompanyPayeeServiceCall({
            ...error,
            requestData,
          });
        } else {
          // Handling the error response
          MoveMoneyPayeeActionCreator.handleAddCompanyPayeeServiceCall({
            code: 422,
          });
        }
      }
    );
  },

  /*
    Getting List of Company
    */
  getCompany(requestData) {
    let url = envConfig.apiBaseUrlPAAS + _getCompanyUrl;
    if (envConfig.stubConfig) {
      // TODO need to discuss with the team
      url = envConfig.stubConfig.paymentStub.AddPayeeConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.payeeService,
        method: 'POST',
        url,
        requestData,
        addAuthToken: true,
      },
      (body) => {
        const resp = body;
        resp.code = 201;
        MoveMoneyPayeeActionCreator.handleCompanySearchServiceCall(resp);
      },
      (errors) => {
        if (errors !== undefined) {
          const error = errors;
          error.code = 409;
          // handle error of Company payee service call
          MoveMoneyPayeeActionCreator.handleCompanySearchServiceCall(error);
        } else {
          // handle error of Company payee service call
          MoveMoneyPayeeActionCreator.handleCompanySearchServiceCall({
            code: 409,
          });
        }
      }
    );
  },

  putRetailPayee(requestData, accountId, beneficiaryId) {
    const url = `${envConfig.apiBaseUrlPAAS}${_putRetailPayeeUrl}`
      .replace('{accountId}', accountId)
      .replace('{beneficiaryId}', beneficiaryId);

    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.payeeService,
        method: 'PUT',
        url,
        addAuthToken: true,
        requestData,
      },
      (response) => {
        MoveMoneyPayeeActionCreator.handlePutRetailPayeeSuccess({
          ...response,
          code: 201,
          accountId,
          /**
           * This endpoint recreates the beneficiary (by DELETE & CREATE).
           * To update our stored list we need to bring the initial payee id
           */
          initialBeneficiaryId: beneficiaryId,
        });
      },
      (_error, status) => {
        if (status === 401) {
          MoveMoneyPayeeActionCreator.storeUnauthorisedBeneficiaryDetails(
            requestData
          );
          SessionActionCreator.initStepUpMode();

          return;
        }

        MoveMoneyPayeeActionCreator.handlePutRetailPayeeError();
        InternetBankingActions.navigateToWebTask('WEB-ERROR');
      }
    );
  },

  /*
    Editing the payee
    @Description This method will first delete the payee
    and on succes of delete payee add payee will be called
  */
  deleteAndPostPayeeSequentially(requestData, accountId, beneficiaryId) {
    const url = `${envConfig.apiBaseUrlPAAS}${_deletePayeeUrl}`
      .replace('{accountId}', accountId)
      .replace('{beneficiaryId}', beneficiaryId);

    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.payeeService,
        method: 'DELETE',
        url,
        addAuthToken: true,
      },
      () => {
        MoveMoneyPayeeActionCreator.handleDeletePayeeSuccess({
          code: 201,
          beneficiaryId,
        });

        if (requestData.hasOwnProperty('biller_id')) {
          this.addCompany(requestData, accountId, true);
        } else {
          this.addPayee(requestData, accountId, true);
        }
      },
      (errors) => {
        const error = errors;
        if (error !== undefined) {
          error.code = 422;
          MoveMoneyPayeeActionCreator.handlePayeeServiceCall(error);
        } else {
          MoveMoneyPayeeActionCreator.handlePayeeServiceCall({ code: 422 });
        }
      }
    );
  },

  /**
   * method: addPayee
   * request: addPayee data and accountId
   * description:This method will make a ajax call to add a payee for a particular account
   */
  addPayee(requestData, accountId, isForEdit = false) {
    // replacing the accountId
    const addPayeeUrl = _addPayeeUrl.replace('{accountId}', accountId);
    let url = envConfig.apiBaseUrlPAAS + addPayeeUrl;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.paymentStub.AddPayeeConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.payeeService,
        method: envConfig.stubConfig ? 'Get' : 'Post',
        url,
        requestData,
        addAuthToken: true,
      },
      (resp) => {
        const body = resp;
        body.code = 201;
        body.accountId = accountId;
        if (isForEdit) {
          MoveMoneyPayeeStore.handlingErrorWhilePayeeEdit(false);
        }
        // Handling the success response
        MoveMoneyPayeeActionCreator.handleAddPayeeServiceCall(body);
      },
      (errors, status) => {
        if (status === 401) {
          MoveMoneyPayeeActionCreator.storeUnauthorisedBeneficiaryDetails(
            requestData
          );
          SessionActionCreator.initStepUpMode();

          /**
           * Early return to block MoveMoneyPayeeStore
           * from emitting unnecessary changes
           */
          return;
        }

        if (errors !== undefined) {
          const error = errors;
          error.code = 422;
          error.status = status;
          if (isForEdit) {
            MoveMoneyPayeeStore.errorToAddPayee(true);
            MoveMoneyPayeeStore.handlingErrorWhilePayeeEdit(true);
          }
          // Handling the error response
          MoveMoneyPayeeActionCreator.handleAddPayeeServiceCall(error);
        } else {
          // Handling the error response
          MoveMoneyPayeeActionCreator.handleAddPayeeServiceCall({
            code: 422,
            status,
          });
        }
      }
    );
  },
  /*
   * method: deletePayee
   * request: deletPayeeRequestData
   * description:This method will make a ajax call to delete a payee for a particular account
   */
  deletePayee({ accountId, beneficiary_id: beneficiaryId }) {
    const url = `${envConfig.apiBaseUrlPAAS}${_deletePayeeUrl}`
      .replace('{accountId}', accountId)
      .replace('{beneficiaryId}', beneficiaryId);

    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.payeeService,
        method: 'DELETE',
        url,
        addAuthToken: true,
      },
      () => {
        // Handling the success response
        const success = {
          code: 201,
          beneficiaryId,
        };
        MoveMoneyPayeeActionCreator.handleDeletePayeeSuccess(success);
      },
      (errors) => {
        let error = errors;
        if (error !== undefined) {
          error.code = 422;
          // Handling the error response
          MoveMoneyPayeeActionCreator.handlePayeeServiceCall(error);
        } else {
          // Handling the error response
          error = { message: 'Internal server error', code: 422 };
          MoveMoneyPayeeActionCreator.handlePayeeServiceCall({ error });
        }
      }
    );
  },

  /**
   * method: getSrdDetails
   * description:This method will make a ajax call to get srd details for this payee
   */
  getSrdDetails(requestData) {
    let url = envConfig.apiBaseUrlPAAS + _verifySrdUrl;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.paymentStub.SRDVerificationConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.payeeService,
        method: 'POST',
        url,
        requestData,
        addAuthToken: true,
      },
      (resp) => {
        // Handling the success response
        MoveMoneyPayeeActionCreator.handleSrdDetailsSuccess(resp);
      },
      (errors) => {
        MoveMoneyPayeeActionCreator.handleSrdDetailsFailure(errors);
      }
    );
  },
};
export default MoveMoneyPayeeApiUtils;
